import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { User } from '@core/account-types';
import { HttpApiService } from '@core/http-legacy';
import type { PaginationMeta, PaginationParams } from '@core/http-types';
import type { InterviewSchedule } from '@core/interview-schedules-types';

import { InterviewSchedulesCollectionScopes } from './collection.types';

@Injectable({ providedIn: 'root' })
export class InterviewSchedulesCollectionHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public loadCollection(
    scope: string,
  ): Observable<{ interviewSchedules: InterviewSchedule[]; references: User[] }> {
    return this.httpApi.get(
      scope === InterviewSchedulesCollectionScopes.Available
        ? 'interview/schedules/available'
        : 'interview/schedules',
    );
  }

  public loadPaginatedCollection(
    params: PaginationParams,
  ): Observable<{ rows: InterviewSchedule[]; meta: PaginationMeta; references: User[] }> {
    return this.httpApi.get('interview/schedules', params).pipe(
      map(data => ({
        meta: data.meta,
        rows: data.interviewSchedules,
        references: data.references,
      })),
    );
  }
}
